import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import Path from '@utils/Path';
import { ProductAttribute_productAttribute } from '@api/graphql/types';
import ProductAttributeOptions from './ProductAttributeOptions';
import Form from '@components/Form/Form';

type Props = {
    formData: ProductAttribute_productAttribute,
    onSubmit: (formData: ProductAttribute_productAttribute) => Promise<any>,
    refetch?: () => void;
} & InjectedIntlProps & RouteComponentProps;

interface State {
    formData: ProductAttribute_productAttribute;
}

class ProductAttributeForm extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            formData: this.props.formData,
        };
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({formData: props.formData});
    }

    private validate = (formData: ProductAttribute_productAttribute) => {
        return true;
    }

    public render() {
        const fields = [
            {name: 'name', type: 'text', props: {required: true}},
            {name: 'code', type: 'text', props: {required: true}},
            {name: 'filterable', type: 'checkbox'},
            {name: 'is_active', type: 'checkbox'},
            {name: 'type', type: 'productattributetype', props: {required: true}},
        ];

        return (
            <>
                <Form
                    fields={[{id: 'default', fields}]}
                    intlPrefix={'module.productAttribute'}
                    onSubmit={this.props.onSubmit}
                    formData={this.props.formData}
                    redirectPath={Path.productAttribute}
                    validate={this.validate}
                />
                <ProductAttributeOptions
                    name="options"
                    productAttributeId={this.props.formData.id}
                    value={this.state.formData.options}
                    onChangeHandler={console.warn}
                    refetch={this.props.refetch}
                />
            </>
        );
    }

}

export default compose(
    injectIntl,
    withRouter,
)(ProductAttributeForm);



// WEBPACK FOOTER //
// ./src/modules/ProductAttribute/components/ProductAttributeForm.tsx